import axios from 'axios';

const getTitle = () => {
  const ogTitle = document.querySelector("meta[property='og:title']");
  return ogTitle && ogTitle.content;
};

const getPrice = () => {
  const ogPrice = document.querySelector("meta[property='og:price:amount']");
  if (ogPrice) {
    return parseFloat(ogPrice.content);
  }

  const salePrice = document.getElementsByClassName('v65-product-addToCart-salePrice');
  const standardPrice = document.getElementsByClassName('v65-product-addToCart-price');
  let price = 0;
  if (salePrice.length) {
    price = salePrice[0].textContent;
  } else {
    price = standardPrice && standardPrice[0].textContent;
  }

  return parseFloat(price.replace('$', ''));
};

const getSKU = () => {
  const sku = document.getElementsByClassName('v65-product-addToCart-productSKU');
  if (!sku.length) {
    return [];
  }

  return [sku[0].textContent.replace('SKU: ', '')];
};

const getOrderDetails = orderId => axios.get(`/index.cfm?method=checkoutV2Review.viewOrderAsJSON&orderID=${orderId}`)
  .then((res) => {
    if (!res.data) {
      return {};
    }

    const { orderItems, orderHeader } = res.data.order;
    return {
      contents: orderItems.map(item => ({
        id: item.sku,
        quantity: item.quantity,
        item_price: item.price,
      })),
      value: parseFloat(orderHeader.orderTotal),
    };
  });

export {
  getTitle,
  getPrice,
  getSKU,
  getOrderDetails,
};
